export default "__VITE_ASSET__93188341__"